import { GridLoader } from 'react-spinners';
import { useSelector } from 'react-redux';

export default function GlobalLoader() {
  const isLoading = useSelector((state) => state.loader.isLoading);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
      <GridLoader color="#2563EB" loading={isLoading} size={18} margin={5} />
    </div>
  );
}
